import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { ISelectOption } from "src/@types/form";

export const INVESTMENTS_SLICE_NAME = "investments";

export const getInvestmentsAsync = createAsyncThunk(
  `${INVESTMENTS_SLICE_NAME}/fetchInvestments`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<ISelectOption[]>(
        "/clones/invest-options/"
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.investments;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
